
import { TranslationRecord } from '../../types';

export const suites: TranslationRecord = {
  // Suites Section
  suitesTitle: 'Η Πολυτελής Σουίτα μας',
  roomFeatures: 'Χαρακτηριστικά Δωματίου',
  bathFeatures: 'Χαρακτηριστικά Μπάνιου',
  generalAmenities: 'Γενικές Παροχές',
  viewAllSuites: 'Δείτε Όλες τις Σουίτες',
  suiteGallery: 'Γκαλερί Σουίτας',
  capacity: 'Χωρητικότητα',
  amenities: 'Παροχές',
  services: 'Υπηρεσίες',
  
  // What Sets Us Apart section
  whatSetsUsApart: 'Τι μας Ξεχωρίζει',
  spaciousLayout: 'Ευρύχωρη Διάταξη',
  guests: 'Επισκέπτες',
  centralLocation: 'Κεντρική τοποθεσία στη Θεσσαλονίκη',
  topRestaurants: 'Κορυφαία εστιατόρια σε κοντινή απόσταση',
  climateControl: 'Έλεγχος κλίματος (A/C και θέρμανση)',
  fullyEquippedKitchen: 'Πλήρως εξοπλισμένη σύγχρονη κουζίνα',
  highSpeedWifi: 'Υψηλής ταχύτητας wifi (100 Mbps)',
  personalizedAttention: 'Εξατομικευμένη προσοχή',
  dailyHousekeeping: 'Καθημερινή υπηρεσία καθαρισμού',
  exceptionalStay: 'Στο Loena Luxury Suites, διασφαλίζουμε ότι η διαμονή σας θα είναι εξαιρετική.',
  viewDetails: 'Δείτε Λεπτομέρειες',
  
  // Suite Hero
  luxurySuite: 'Πολυτελής Σουίτα',
  suiteDescription: 'Βιώστε τη σύγχρονη άνεση στην καρδιά της Θεσσαλονίκης. Η σουίτα μας των 30m² συνδυάζει πολυτελείς παροχές με προσεκτικό σχεδιασμό.',
  suiteSize: '30m²',
  upToGuests: 'Έως 3 επισκέπτες',
  queenSingleBed: 'Queen + Μονό κρεβάτι',
  
  // Suite Features
  queenBed: '1 Queen κρεβάτι, 1 Μονό κρεβάτι',
  babyCot: 'Βρεφική κούνια (κατόπιν αιτήματος)',
  wifi: 'Υψηλής ταχύτητας Wi-Fi (100 Mbps)',
  fullKitchen: 'Πλήρης κουζίνα',
  diningTable: 'Τραπέζι φαγητού',
  hdtv: '55" HDTV',
  airConditioning: 'Κλιματισμός',
  washerDryer: 'Πλυντήριο και στεγνωτήριο',
  hotWater: 'Στιγμιαίο ζεστό νερό 24/7',
  smartLocks: 'Έξυπνες ηλεκτρονικές κλειδαριές',
  waterBottles: 'Πακέτο καλωσορίσματος (νερό, καφές, τσάι)',
  fireSafetyEquipment: 'Εξοπλισμός πυρασφάλειας',
  securityMonitoring: 'Επιτήρηση ασφαλείας 24/7',
  insectScreens: 'Σίτες σε όλα τα παράθυρα',
  dailyCleaning: 'Καθημερινός καθαρισμός',
  luggageStorage: 'Φύλαξη αποσκευών',
  transferServices: 'Υπηρεσίες μεταφοράς',
  restaurantRecommendations: 'Προτάσεις εστιατορίων',
  earlyCheckIn: 'Πρώιμο check-in',
  lateCheckout: 'Όψιμο check-out (ανάλογα με τη διαθεσιμότητα)',
  corporateInvoicing: 'Επιλογή εταιρικής τιμολόγησης',
  ironIroningBoard: 'Σίδερο και σιδερώστρα',
  washerDryerExtraCharge: 'Πλυντήριο / στεγνωτήριο (επιπλέον χρέωση)',
  accommodates: "Φιλοξενεί",
  upToThreeGuests: "Έως 3 επισκέπτες",
  
  // Amenities
  premiumAmenities: 'Πολυτελείς Παροχές',
  amenitiesDescription: 'Κάθε λεπτομέρεια έχει σχεδιαστεί προσεκτικά για να διασφαλίσει την άνεση και την ευκολία σας κατά τη διαμονή σας.',
  highSpeedWifiTitle: 'Υψηλής Ταχύτητας WiFi',
  wifiDescription: '100 Mbps δωρεάν internet',
  smartTv: '55" Smart TV',
  tvDescription: 'Netflix και premium κανάλια περιλαμβάνονται',
  climateControlTitle: 'Έλεγχος Κλίματος',
  climateDescription: 'Ατομικός κλιματισμός',
  fullKitchenTitle: 'Πλήρης Κουζίνα',
  kitchenDescription: 'Ψυγείο, φούρνος και μαγειρικά σκεύη',
  laundry: 'Πλυντήριο',
  laundryDescription: 'Πλυντήριο και στεγνωτήριο στη μονάδα',
  smartLocksTitle: 'Έξυπνες Κλειδαριές',
  smartLocksDescription: 'Ηλεκτρονική είσοδος χωρίς κλειδί',
  hotWaterTitle: 'Ζεστό Νερό',
  hotWaterDescription: 'Στιγμιαίο ζεστό νερό 24/7',
  parking: 'Πάρκινγκ',
  parkingDescription: 'Ασφαλές πάρκινγκ διαθέσιμο κοντά',
  
  // Additional fields
  privateBathroom: 'Ιδιωτικό Μπάνιο',
  livingArea: 'Χώρος Καθιστικού',
  balcony: 'Μπαλκόνι',
  heating: 'Θέρμανση',
  freeWifi: 'Δωρεάν Wi-Fi',
  flatScreenTV: 'Επίπεδη Τηλεόραση',
  hairDryer: 'Στεγνωτήρας Μαλλιών',
  toiletries: 'Είδη Προσωπικής Φροντίδας',
  miniBar: 'Μίνι Μπαρ',
  safeBox: 'Χρηματοκιβώτιο',
  ironingFacilities: 'Εγκαταστάσεις Σιδερώματος',
  soundproofing: 'Ηχομόνωση',
  modernDesign: 'Μοντέρνος Σχεδιασμός',
  premiumLocation: 'Προνομιακή Τοποθεσία',
  luxuryAmenities: 'Πολυτελείς Παροχές',
  maxOccupancy: 'Μέγιστη Χωρητικότητα',
  bedType: 'Τύπος Κρεβατιού',
  viewType: 'Τύπος Θέας',
  perfectFor: 'Ιδανικό για',
  couples: 'ζευγάρια',
  businessTravelers: 'επαγγελματικά ταξίδια',
  shortStays: 'βραχείς παραμονές',
  bathroomImage: 'Εικόνα Μπάνιου',
  bedroomImage: 'Εικόνα Υπνοδωματίου',
  livingRoomImage: 'Εικόνα Καθιστικού',
  kitchenImage: 'Εικόνα Κουζίνας',
  balconyImage: 'Εικόνα Μπαλκονιού',
  
  // Gallery
  suiteGalleryTitle: 'Γκαλερί Σουίτας',
  galleryDescription: 'Κάντε μια εικονική περιήγηση στο πολυτελές κατάλυμά μας',
  viewImage: 'Δείτε Εικόνα',
  closeGallery: 'Κλείσιμο γκαλερί',
  previousImage: 'Προηγούμενη εικόνα',
  nextImage: 'Επόμενη εικόνα',
  
  // Missing keys from components
  bathroom: 'Μπάνιο',
  space: 'Χώρος',
  features: 'Χαρακτηριστικά',
  bookThisSuite: 'Κράτηση Σουίτας'
};
